import { DocsView } from "./_components";

export default function DocsPage() {
  return <DocsView />;
}
